import {observer} from "mobx-react";
import React, {useEffect} from "react";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import HeaderModal from "@dropDesk/presentation/components/headers/header_modal";
import ModalMain from "@dropDesk/presentation/components/modals/modal_main";
import {
    ContainerBox,
    ContainerModal,
    Content, TextEllipsis,
} from "@dropDesk/presentation/pages/sector/ui/orders_sectors/styled";
import {SharedColors} from "@dropDesk/domain/entities/theme/app_colors";
import {DragDropContext, Draggable, Droppable, DropResult} from "@hello-pangea/dnd";
import {SectorEntity} from "@dropDesk/domain/entities/sector/sector.entity";
import DropDeskLoading from "@dropDesk/presentation/components/loadings/loading_dropdesk";
import DropDeskLoadingDefault from "@dropDesk/presentation/components/loadings/loading_table";
import FooterModal from "@dropDesk/presentation/components/footer/footer_modal";


const ModalOrderSectors = observer(
    ({
         setVisibleModalOrderSectors,
         visibleModalOrderSectors,
         list,
         sectors,
         onDragEnd,
         loading,
         resetTableOrderSector,
         onSaveOrderSectors
     }: {
        visibleModalOrderSectors: boolean
        setVisibleModalOrderSectors: () => void
        list: () => Promise<void>
        sectors: SectorEntity[]
        onDragEnd: (value: DropResult) => void
        loading: boolean
        resetTableOrderSector: () => void
        onSaveOrderSectors: () => Promise<void>
    }) => {

        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;

        useEffect(() => {
            list().then();
            return () => {
                resetTableOrderSector();
            }
        }, []);

        const handleSubmit = async () => {
            setVisibleModalOrderSectors();
            await onSaveOrderSectors();
        }

        return (
            <ModalMain
                open={visibleModalOrderSectors}
                onRequestClose={() => setVisibleModalOrderSectors()}
                width={600}
                ignoreCloseOnClickOutside={true}
                renderComponent={
                    <ContainerModal background={colors.delicateBackground}>
                        <HeaderModal
                            disabled={loading}
                            letter={'Ordenar Exibição dos Setores'}
                            nameIcon={ICONS_DROPDESK.close}
                            onClick={() => setVisibleModalOrderSectors()}
                            background={colors.delicateBackground}
                            letterColor={colors.text}
                            titleInfo={'Arraste os setores para cima ou para baixo para definir em que ordem eles aparecem para seus clientes'}
                        />
                        <Content background={colors.delicateBackground}>
                            <DragDropContext onDragEnd={(value) => onDragEnd(value)}>
                                <Droppable droppableId="sectors">
                                    {(droppableProvider) => (
                                        <div
                                            ref={droppableProvider.innerRef}
                                            {...droppableProvider.droppableProps}
                                        >
                                            {sectors.map((sector) => (
                                                <Draggable
                                                    index={sector.position}
                                                    key={sector.id}
                                                    draggableId={`${sector.id}`}
                                                >
                                                    {(draggableProvider) => (
                                                        <ContainerBox
                                                            ref={draggableProvider.innerRef}
                                                            {...draggableProvider.draggableProps}
                                                            {...draggableProvider.dragHandleProps}
                                                            background={colors.onBackground}
                                                            color={colors.text}
                                                        >
                                                            <TextEllipsis>
                                                                {sector.name}
                                                            </TextEllipsis>
                                                        </ContainerBox>
                                                    )}
                                                </Draggable>
                                            ))}
                                            {droppableProvider.placeholder}
                                        </div>
                                    )}
                                </Droppable>
                            </DragDropContext>
                            {loading && <DropDeskLoadingDefault
                                height={100}
                                description={"Carregando ..."}
                            />}
                        </Content>
                        <FooterModal
                            disabled={loading}
                            loading={loading}
                            type={"submit"}
                            letter={'Salvar'}
                            onSubmit={handleSubmit}
                            background={colors.delicateBackground}
                            backgroundBackButton={colors.delicateBackground}
                            onRequestClose={() => setVisibleModalOrderSectors()}
                        />
                    </ContainerModal>
                }
            />
        )
    })
export default ModalOrderSectors;
